<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">RSVP</h1>
            <h4 v-if="isCeremonyGuest">
              You are cordially invited to come celebrate the marriage of Matthew
              Petrie and Charles Juszczak on May 30th, 2020 at Woven Wineworks in downtown
              Portland, Oregon at 5:30 PM. A reception celebrating their marriage will be held the 
              following day on May 31st, 2020 at McMenamins Cornelius Pass Roadhouse in Hillsboro, 
              Oregon. We look forward to seeing you!
            </h4>
            <h4 v-else>
              Matt and Charlie will be married in a small ceremony on Saturday the 30th of May, 2020.
              Please join us in celebration at their wedding reception Sunday the 31st of May, 2020
              at McMenamins Cornelius Pass Roadhouse Octagonal Barn & Barnyard in Hillsboro, Oregon
              from 1-4 PM.
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">RSVP</h2>
              <h5 class="description" v-if="isSubmitted && !isProcessing">
                Please let us know if you can make it, we would love to see you!
              </h5>
            </div>
          </div>
          <div class="features text-center" v-if="isSubmitted && !isProcessing">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-50 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>check_circle_outline</md-icon>
                  </div>
                  <h4 class="info-title">Response Submitted</h4>
                  <p>
                    <strong>Thanks for submitting your RSVP response. You are good to go!</strong><br />
                    <br /><br />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="features text-center" v-if="!isSubmitted && isProcessing">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-50 md-small-size-100">
                <div class="info">
                  <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
                  <h4 class="info-title">Submitting RSVP Response</h4>
                  <p>
                    <strong>Please hold on.</strong><br />
                    <br /><br />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="features text-center" v-if="!isSubmitted && !isProcessing">
            <form novalidate @submit.prevent="validateRsvp">
            <h3 class="title">Your Information</h3>
            <div class="md-layout">
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <md-field class="md-form-group" :class="getValidationClass('firstName')">
                  <md-icon>face</md-icon>
                  <md-input
                    v-model="firstName"
                    placeholder="First Name"
                  ></md-input>
                  <span class="md-error" v-if="!$v.firstName.required">First name is required</span>
                  <span class="md-error" v-else-if="!$v.firstName.minlength">Invalid first name</span>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <md-field class="md-form-group" :class="getValidationClass('lastName')">
                  <i class="fas fa-users"></i>
                  <md-input
                    v-model="lastName"
                    placeholder="Last Name"
                  ></md-input>
                  <span class="md-error" v-if="!$v.lastName.required">The last name is required</span>
                  <span class="md-error" v-else-if="!$v.lastName.minlength">Invalid last name</span>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
            </div>
            <div class="md-layout">
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <md-field class="md-form-group" :class="getValidationClass('emailAddress')">
                  <md-icon>email</md-icon>
                  <md-input
                    v-model="emailAddress"
                    placeholder="Email Address"
                    type="email"
                  ></md-input>
                  <span class="md-error" v-if="!$v.emailAddress.required">Email address is required</span>
                  <span class="md-error" v-else-if="!$v.emailAddress.minlength">Invalid email address</span>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <md-field class="md-form-group">
                  <i class="fas fa-phone"></i>
                  <md-input
                    v-model="phoneNumber"
                    placeholder="Phone Number"
                  ></md-input>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
            </div>
            <div class="md-layout">
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <md-field class="md-form-group" :class="getValidationClass('numGuests')">
                  <md-icon>person_add</md-icon>
                  <md-input
                    v-model="numGuests"
                    placeholder="Total number attending"
                  ></md-input>
                  <span class="md-error" v-if="!$v.numGuests.required">Total number of guests is required</span>
                  <span class="md-error" v-else-if="!$v.numGuests.between">Please provide a number between 0 and 10</span>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
            </div>
            <h3 class="title" v-if="isCeremonyGuest">Ceremony Response</h3>
            <p v-if="isCeremonyGuest">5:30 PM on Saturday, May 30th, 2020</p>
            <div class="md-layout" v-if="isCeremonyGuest">
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
              <div
                class="md-layout-item md-size-50 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <div class="flex-column">
                  <md-radio v-model="ceremony" :value="true">Yes, I/we will be attending the ceremony</md-radio>
                  <md-radio v-model="ceremony" :value="false">Unfortunately I/we cannot attend</md-radio>
                </div>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
            </div>
            <h3 class="title">Reception Response</h3>
            <p>1-4 PM on Sunday, May 31st, 2020</p>
            <div class="md-layout">
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
              <div
                class="md-layout-item md-size-50 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <div class="flex-column">
                  <md-radio v-model="reception" :value="true">Yes, I/we will be attending the reception</md-radio>
                  <md-radio v-model="reception" :value="false">Unfortunately I/we cannot attend</md-radio>
                </div>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
            </div>
            <h3 class="title">Notes</h3>
            <div class="md-layout">
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
              <div
                class="md-layout-item md-size-50 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
                <md-field maxlength="5">
                  <label>Please include any dietary restrictions, food allergies, or other notes.</label>
                  <md-textarea v-model="notes"></md-textarea>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
              >
              </div>
            </div>
            <br />
            <br />
            <md-button
              class="md-primary md-lg"
              type="submit"
              ><i class="material-icons">card_giftcard</i> Submit RSVP Response</md-button
            >
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
    minLength,
    maxLength,
    integer,
    between
  } from 'vuelidate/lib/validators'

export default {
  name: "rsvp",
  bodyClass: "landing-page",
  mixins: [validationMixin],
  props: {
    header: {
      type: String,
      default: require("@/assets/img/rsvp_background.jpg")
    }
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      emailAddress: null,
      phoneNumber: null,
      numGuests: null,
      reception: true,
      ceremony: false,
      notes: undefined,
      submitted: false,
      processing: false
    };
  },
  validations: {
    firstName: {
      required,
      minLength: minLength(3)
    },
    lastName: {
      required,
      minLength: minLength(3)
    },
    emailAddress: {
      required,
      email
    },
    numGuests: {
      required,
      between: between(0, 10)
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    isCeremonyGuest() {
      if (this.$parent.user.username === 'ceremony') {
        this.ceremony = true;
      }

      return this.$parent.user.username === 'ceremony';
    },
    isSubmitted() {
      return this.submitted;
    },
    isProcessing() {
      return this.processing;
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    submitRsvp() {
      this.processing = true;

      const path = '/rsvps';
      const apiName = 'rsvps';
      const myInit = {
        body: {
          firstName: this.firstName,
          lastName: this.lastName,
          emailAddress: this.emailAddress,
          phoneNumber: this.phoneNumber,
          numGuests: this.numGuests,
          reception: this.reception,
          ceremony: this.ceremony,
          notes: this.notes
        }
      };

      this.$Amplify.API.post(apiName, path, myInit)
      .then((result) => {
        this.processing = false;
        this.submitted = true;
      })
      .catch((error) => {
        console.log('error creating item-->', error);
      })
    },
    validateRsvp () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.submitRsvp()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
